import { render } from "./DialogComponent.vue?vue&type=template&id=2c0a2c47&ts=true"
import script from "./DialogComponent.vue?vue&type=script&lang=ts"
export * from "./DialogComponent.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__